module.exports = __webpack_public_path__ + "img/Toms-Sarmanis.ca0e2323.svg";